// extracted by mini-css-extract-plugin
module.exports = {"componentsTitle":"style_componentsTitle___n_w0","list":"style_list__iDySv","category":"style_category__rM_QQ"};